import React from 'react';
import PropTypes from 'prop-types';

export default class ListingControlsWrapper extends React.PureComponent {

    render() {

        let {isControlsOpened, isControlsShowing, onOverlayClick} = this.props.controls;

        return (
            <div
                className={`listing-controls lots-search__controls ${isControlsOpened ? 'is-shown' : ''} ${isControlsShowing ? 'is-showing' : ''}`}>
                <div
                    className="listing-controls__overlay"
                    onClick={onOverlayClick}/>
                <div className="listing-controls__content">
                    <div className="listing-controls__container">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

ListingControlsWrapper.propTypes = {
    controls: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/listing/js/ListingControlsWrapper.js